import React, { useEffect, useState } from "react"
import { TextTag } from "../../atoms"
import _ from "../../utils/lodashUtils"
import { PageHeader } from "../../molecules/PageHeader"
import {
  EMPTY_RESTAURANTS_HEADER,
  EMPTY_RESTAURANTS_MESSAGE,
  OPEN_RESTAURANTS_HEADER_WITH_USER_ADDRESS,
  OPEN_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS,
  OPEN_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS,
  OPEN_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS,
  CLOSED_RESTAURANTS_HEADER_WITH_USER_ADDRESS,
  CLOSED_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS,
  CLOSED_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS,
  CLOSED_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS,
  NO_RESTAURANTS_HEADER_WITH_USER_ADDRESS,
  NO_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS,
  NO_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS,
  NO_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS,
  BACK_BUTTON,
  GET_ADDRESS_WAITING_SCREEN_TITLE,
  BACK_TO_PLAN_A_DATE_SCREEN_USER,
  BACK_TO_PLAN_A_DATE_SCREEN_PARTNER,
  CHANGE_ADDRESS_TITLE,
  INVALID_ADDRESS,
  VALIDATING_ADDRESS,
  USE_PARTNER_ADDRESS,
  SEARCH_ADDRESS_LABEL,
  SEARCH_PARTNER_ADDRESS_LABEL,
  USING_PARTNER_ADDRESS,
  USING_YOUR_ADDRESS,
  COMBINED_ORDER_TOOLTIP,
  PARTNER_ADDRESS_SEARCH_PLACEHOLDER,
} from "../../constants/messages"
import { FirebaseService, FirebaseContext } from "../../firebase"
import { FIREBASE_STATE_KEYS } from "../../firebase"
import { ArrowLeftOutlined, QuestionCircleFilled } from "@ant-design/icons"
import PartnerAway from "../../components/PartnerAway/PartnerAway"
import { connect } from "react-redux"
import RestaurantList from "../../components/RestaurantList/RestaurantList"
import {
  isPartnerAway,
  getOpenRestaurants,
  getGenderSpecificMessage,
} from "../../utils/helpers"
import { invitePartnerToChat } from "../../redux/actionCreators/invitePeople"
import Separator from "../../components/Separator/Separator"
import {
  getRestaurants,
  checkCommonRestaurantsForUs,
  validateUserAddress,
} from "../../redux/actionCreators/planDinnner"
import { SCREENS } from "../../constants/screens"
import { updateAddress } from "../../redux/actionCreators/auth"
import AddressSearchBar from "../../components/AddressSearchBar/AddressSearchBar"

import "./DateWaitPage.scss"
import BlockingModal from "../../components/BlockingModal/BlockingModal"
import TableChair from "../../assets/images/TableChair.svg"
import { ActivityIndicator } from "../../components/ActivityIndicator"
import { DRAFT_ADDRESS_MODES } from "../../constants/commons"
import { Tooltip } from "antd"
import checkbox from "../../assets/images/checkbox-tick.svg"
import checkboxUntick from "../../assets/images/checkbox-untick.svg"
import Tag from "../../components/Tag/Tag"

const DateWaitPage = props => {
  const { user, checkCommonRestaurantsForUs } = props
  const fbContext = React.useContext(FirebaseContext)
  const { dateState, partnerState, userState } = fbContext
  const firebaseDefaultPath = FirebaseService.getDefaultPath()
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const userId = _.get(user, "uuid")
  const showPartnerAway =
    isPartnerAway(partnerScreen, partnerOnline) ||
    partnerScreen === SCREENS.PLAN_NEW_DATE
  const [firstUserToSaveAddress, setfirstUserToSaveAddress] = useState(null)
  const [restaurantsList, setRestaurantList] = useState([])
  const [restaurantsListLoading, setRestaurantListLoading] = useState(false)
  const [openRestaurantsCount, setOpenRestaurantsCount] = useState([])
  const [userCancelModal, setUserCancelModal] = useState(false)
  const [usingPartnerAddress, setusingPartnerAddress] = useState(false)
  const [partnerCancelModal, setPartnerCancelModal] = useState(false)
  const partnerName = _.get(partnerState, "userDetails.display_name", "Partner")
  const partnerGender = _.get(partnerState, "userDetails.gender", "he")
  const partnerGenderSubjectiveMessage = getGenderSpecificMessage(
    partnerGender,
    "SUBJECTIVE"
  )
  const partnerGenderObjectiveMessage = getGenderSpecificMessage(
    partnerGender,
    "OBJECTIVE"
  )
  const partnerGenderPossessiveMessage = getGenderSpecificMessage(
    partnerGender,
    "POSSESSIVE"
  )
  const currentUserAddress = _.get(props.user, "address.user_address")
  const userAddress = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DRAFT_ADDRESS}`,
    {
      value: currentUserAddress || "",
      mode: currentUserAddress
        ? DRAFT_ADDRESS_MODES.SAVE
        : DRAFT_ADDRESS_MODES.EMPTY,
      isChecked: false,
    }
  )
  const partnerAddress = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.DRAFT_ADDRESS}`,
    {
      value: "",
      mode: DRAFT_ADDRESS_MODES.EMPTY,
      isChecked: false,
    }
  )
  const userAddressMode = _.get(userAddress, "mode", DRAFT_ADDRESS_MODES.EDIT)
  const partnerAddressMode = _.get(
    partnerAddress,
    "mode",
    DRAFT_ADDRESS_MODES.EDIT
  )
  const [isValidAddress, setIsValidAddress] = useState(null)
  const [addressError, setAddressError] = useState("")

  // Redirect the partner to plan a new date screen if a user moves back

  const planANewDate = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.PLAN_A_DATE}`,
    true
  )
  useEffect(() => {
    if (!planANewDate) {
      setPartnerCancelModal(true)
    }
  }, [planANewDate])

  // Redirect the User to Restaurants screen if both mode is saved
  useEffect(() => {
    if (
      userAddressMode === partnerAddressMode &&
      userAddressMode === DRAFT_ADDRESS_MODES.SAVE &&
      userAddress.value.trim() &&
      partnerAddress.value.trim()
    ) {
      FirebaseService.setActiveRoute("/choose-restaurant")
      props.history.push("/choose-restaurant")
    }
  }, [userAddressMode, partnerAddressMode, usingPartnerAddress])

  const checkRestaurantsForUs = address => {
    if (address) {
      setRestaurantListLoading(true)
      // Reusing the existing API
      // TODO: Update the backend API to return restaurants list based on a given address
      checkCommonRestaurantsForUs(address, address).then(success => {
        // if (_.isEmpty(success)) setShowMessage(true)
        if (success) {
          const _restuarantsList = Object.values(success)
          setRestaurantList(_restuarantsList)
          setRestaurantListLoading(false)
          const openRestaurants = getOpenRestaurants(_restuarantsList)
          setOpenRestaurantsCount(_.get(openRestaurants, "length", 0))
        }
      })
    }
  }
  useEffect(() => {
    if (userAddressMode === DRAFT_ADDRESS_MODES.SAVE) {
      setfirstUserToSaveAddress("USER")
      checkRestaurantsForUs(userAddress.value)
    }
  }, [userAddress.mode])

  useEffect(() => {
    if (partnerAddressMode === DRAFT_ADDRESS_MODES.SAVE) {
      setfirstUserToSaveAddress("PARTNER")
      checkRestaurantsForUs(partnerAddress.value)
    }
  }, [partnerAddress.mode])
  // TODO: Update it based on the first User to save address

  // Render Default Restaurant
  const renderDefaultRestaurants = () => {
    return (
      <React.Fragment>
        <div className="address-section-header">
          <TextTag>{EMPTY_RESTAURANTS_HEADER}</TextTag>{" "}
        </div>
        <Separator />
        <div className="address-section-message">
          <TextTag>{EMPTY_RESTAURANTS_MESSAGE}</TextTag>
        </div>
        <div>
          <img src={TableChair} alt="waiting" />
        </div>
      </React.Fragment>
    )
  }

  const toggleCheckbox = () => {
    setusingPartnerAddress(!usingPartnerAddress)
  }

  // Render Empty Restaurants
  const renderNoRestaurants = () => {
    return (
      <React.Fragment>
        <div className="address-section-header">
          <TextTag>
            {firstUserToSaveAddress === "USER"
              ? NO_RESTAURANTS_HEADER_WITH_USER_ADDRESS
              : NO_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS(partnerName)}{" "}
          </TextTag>
        </div>
        <Separator />
        <div className="address-section-message">
          <TextTag>
            {firstUserToSaveAddress === "USER"
              ? NO_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS(
                  partnerName,
                  partnerGenderSubjectiveMessage,
                  partnerGenderObjectiveMessage
                )
              : NO_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS(
                  partnerName,
                  partnerGenderPossessiveMessage
                )}
          </TextTag>
        </div>
        <div>
          <img src={TableChair} alt="waiting" />
        </div>
      </React.Fragment>
    )
  }

  const updateFirebaseWithAddress = async (value, mode) => {
    setAddressError("")
    if (mode === DRAFT_ADDRESS_MODES.SAVE) {
      props.updateAddress(
        value,
        false,
        false,
        partnerAddressMode === DRAFT_ADDRESS_MODES.SAVE, // Check combined order if partner is in save mode
        partnerAddress.isChecked
      )
      if (partnerAddress.isChecked) {
        await FirebaseService.patch(
          {
            [FIREBASE_STATE_KEYS.DRAFT_ADDRESS]: {
              ...partnerAddress,
              value: value,
            },
          },
          `${firebaseDefaultPath}${props.partner.uuid}/${[
            FIREBASE_STATE_KEYS.USER_DETAILS,
          ]}`
        )
      }
    }

    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.DRAFT_ADDRESS]: {
          value: value,
          mode: mode,
          isChecked: usingPartnerAddress,
        },
      },
      `${firebaseDefaultPath}${props.user.uuid}/${[
        FIREBASE_STATE_KEYS.USER_DETAILS,
      ]}`
    )
  }

  const updateFirebaseCheckBoxState = async () => {
    //update firebase on who checked the box
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.DRAFT_ADDRESS]: {
          ...userAddress,
          isChecked: usingPartnerAddress,
        },
      },
      `${firebaseDefaultPath}${props.user.uuid}/${[
        FIREBASE_STATE_KEYS.USER_DETAILS,
      ]}`
    )
  }
  useEffect(() => {
    //if one user checks the box, take address from partner
    if (usingPartnerAddress) {
      updateFirebaseWithAddress(partnerAddress.value, DRAFT_ADDRESS_MODES.SAVE)
    } else {
      updateFirebaseCheckBoxState()
    }
  }, [usingPartnerAddress])

  // Render Restaurants
  const renderRestaurants = () => {
    const allClosedRestaurants = openRestaurantsCount === 0 ? true : false
    const count = _.get(restaurantsList, "length", 0)
    let headerText = ""
    let messageText = ""
    if (allClosedRestaurants) {
      if (firstUserToSaveAddress === "USER") {
        headerText = CLOSED_RESTAURANTS_HEADER_WITH_USER_ADDRESS(count)
        messageText = CLOSED_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS(
          partnerName,
          partnerGenderSubjectiveMessage,
          partnerGenderObjectiveMessage
        )
      } else {
        headerText = CLOSED_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS(
          count,
          partnerName
        )
        messageText = CLOSED_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS(
          partnerName,
          partnerGenderPossessiveMessage,
          partnerGenderObjectiveMessage
        )
      }
    } else {
      if (firstUserToSaveAddress === "USER") {
        headerText = OPEN_RESTAURANTS_HEADER_WITH_USER_ADDRESS(count)
        messageText = OPEN_RESTAURANTS_MESSAGE_WITH_USER_ADDRESS(
          partnerName,
          partnerGenderPossessiveMessage
        )
      } else {
        headerText = OPEN_RESTAURANTS_HEADER_WITH_PARTNER_ADDRESS(
          count,
          partnerName
        )
        messageText = OPEN_RESTAURANTS_MESSAGE_WITH_PARTNER_ADDRESS
      }
    }
    return (
      <React.Fragment>
        <div className="address-section-header">
          <TextTag>{headerText}</TextTag>
        </div>
        <Separator />
        <div className="address-section-message">
          <TextTag>{messageText}</TextTag>
        </div>
        <RestaurantList
          isSuggestRequired={true}
          showClosed={true}
          isPartnerAway={true}
          restaurantsList={restaurantsList}
          isDateWait={true}
        />
      </React.Fragment>
    )
  }
  return (
    <div id="getAddressPage">
      <BlockingModal
        withOptions
        title={BACK_TO_PLAN_A_DATE_SCREEN_USER}
        blockingModalVisibility={userCancelModal}
        continueHandler={async () => {
          FirebaseService.patch(
            {
              [FIREBASE_STATE_KEYS.PLAN_A_DATE]: false,
            },
            `${firebaseDefaultPath}`
          )
          setUserCancelModal(false)
          await FirebaseService.setActiveRoute("/plan-new-date")
          props.history.push("/plan-new-date")
        }}
        cancelHandler={() => setUserCancelModal(false)}
      />
      <BlockingModal
        title={BACK_TO_PLAN_A_DATE_SCREEN_PARTNER(partnerName)}
        blockingModalVisibility={partnerCancelModal}
        continueHandler={async () => {
          await FirebaseService.setActiveRoute("/plan-new-date")
          props.history.push("/plan-new-date")
          setPartnerCancelModal(false)
        }}
      />
      <section className="page-container">
        {showPartnerAway && <PartnerAway {...props} />}
        <PageHeader
          onClick={() => {
            setUserCancelModal(true)
          }}
          icon={<ArrowLeftOutlined />}
          headerText={GET_ADDRESS_WAITING_SCREEN_TITLE}
          disabled={showPartnerAway}
          btnText={BACK_BUTTON}
        />
        <div className="date-address-container">
          <div className="address-searchbar-container">
            <div className={` ${usingPartnerAddress ? "label-row" :''}`}>
            <TextTag className="address-label">{SEARCH_ADDRESS_LABEL}</TextTag>
            {usingPartnerAddress && (
              <div className="combine-address-tag">
                <Tag text={USING_PARTNER_ADDRESS(partnerName)} icon={false} />
              </div>
            )}
            </div>
            <AddressSearchBar
              name="userAddress"
              placeholder={CHANGE_ADDRESS_TITLE}
              address={
                usingPartnerAddress ? partnerAddress.value : userAddress.value
              }
              mode={userAddressMode}
              icon={
                usingPartnerAddress
                  ? null
                  : userAddressMode === DRAFT_ADDRESS_MODES.EDIT
                  ? "edit"
                  : "saved"
              }
              onIconClick={async value => {
                const updatedMode =
                  userAddressMode === DRAFT_ADDRESS_MODES.EDIT
                    ? DRAFT_ADDRESS_MODES.SAVE
                    : DRAFT_ADDRESS_MODES.EDIT
                const _value = value ? value : _.get(userAddress, "value", "")
                if (updatedMode === DRAFT_ADDRESS_MODES.SAVE) {
                  setAddressError(VALIDATING_ADDRESS)
                  props
                    .validateUserAddress(_value, "", () => {
                      updateFirebaseWithAddress(_value, updatedMode)
                    })
                    .then(response => {
                      try {
                        if (!_value.trim()) {
                          setAddressError(INVALID_ADDRESS)
                        } else if (_.get(response, "status") === 400)
                          if (response.data.error === "No restaurant available")
                            updateFirebaseWithAddress(_value, updatedMode)
                          else setAddressError(response.data.error)
                      } catch (error) {
                        console.error("error", error)
                      }
                    })
                } else {
                  updateFirebaseWithAddress(_value, updatedMode)
                  setAddressError("")
                }
              }}
              disabled={
                userAddressMode === DRAFT_ADDRESS_MODES.SAVE ||
                userAddressMode === DRAFT_ADDRESS_MODES.EMPTY ||
                usingPartnerAddress
              }
              setAddress={value => {
                updateFirebaseWithAddress(value, userAddressMode)
              }}
              setMode={mode => {
                updateFirebaseWithAddress(_.get(userAddress, "value", ""), mode)
              }}
            />
            {addressError && (
              <TextTag className="address-error" textType="smallTextPrimary">
                {addressError}
              </TextTag>
            )}
          </div>
          <div className="address-searchbar-container">
          <div className={` ${partnerAddress.isChecked ? "label-row" :''}`}>
            <TextTag className="address-label">
              {SEARCH_PARTNER_ADDRESS_LABEL}
            </TextTag>
            {partnerAddress.isChecked && (
              <div className="combine-address-tag">
                <Tag text={USING_YOUR_ADDRESS} icon={false} />
              </div>
            )}
            </div>
            <AddressSearchBar
              placeholder={PARTNER_ADDRESS_SEARCH_PLACEHOLDER(partnerName)}
              address={
                partnerAddress.isChecked
                  ? userAddress.value
                  : partnerAddress.value
              }
              disabled={true}
              mode={partnerAddressMode}
              icon={
                partnerAddressMode === DRAFT_ADDRESS_MODES.EDIT
                  ? "typing"
                  : null
              }
            />
          </div>
        </div>
        <div className="combine-address-container">
            <div className={`checkbox-row ${partnerAddress.isChecked ? "disabled-click": ''}`} onClick={toggleCheckbox}>
              <img
                onClick={toggleCheckbox}
                src={usingPartnerAddress ? checkbox : checkboxUntick}
                alt="checkbox"
                 disabled={partnerAddress.isChecked}
              />
              <TextTag textType="smallTextSecondary" className="text-description">
                  {USE_PARTNER_ADDRESS(partnerName)}{" "}
                  <Tooltip title={COMBINED_ORDER_TOOLTIP}>
                    <QuestionCircleFilled />
                  </Tooltip>
                </TextTag>
            </div>
            </div>
        <div className="date-restaurants-container">
          {userAddressMode === DRAFT_ADDRESS_MODES.SAVE ||
          partnerAddressMode == DRAFT_ADDRESS_MODES.SAVE ? (
            restaurantsListLoading ? (
              <ActivityIndicator />
            ) : _.get(restaurantsList, "length", 0) > 0 ? (
              renderRestaurants()
            ) : (
              renderNoRestaurants()
            )
          ) : _.get(restaurantsList, "length", 0) > 0 ? (
            renderRestaurants()
          ) : (
            renderDefaultRestaurants()
          )}
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    partner: _.get(state, "auth.partner", {}),
  }
}

export default connect(mapStateToProps, {
  getRestaurants,
  updateAddress,
  checkCommonRestaurantsForUs,
  invitePartnerToChat,
  validateUserAddress,
})(DateWaitPage)
